//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import Calendar from 'vue-calendar-component';
import moment from 'moment'
export default {
  name: 'UsersList',
  data() {
    return {
      markDateMore: [],
      user: {},
      recordDataMap: {},
      activeDay: '',
      futureDayHide: '',
      usePer: 0,
      loading: true
    }
  },
  components: {
    Calendar
  },
  mounted() {
    this.getUsersByOpenId()
  },
  methods: {
    cureData () {
      this.getToday()
      this.user.cureRecords && this.user.cureRecords.map((record) => {
        const date = this.getDate(record)
        if (!this.recordDataMap[date]) {
          this.recordDataMap[date] = []
        }
        const activatedAt = this.getDate(this.user.activatedAt)
        if (moment(activatedAt) <= moment(date)) {
          this.recordDataMap[date].push(record)
        } else {
          this.recordDataMap[date] = []
        }
      })
      for (let dateKey in this.recordDataMap) {
        if (this.recordDataMap[dateKey].length > 1) {
          this.markDateMore.push({
            date: dateKey,
            className: 'mark1'
          })
        }
        if (this.recordDataMap[dateKey].length === 1) {
          this.markDateMore.push({
            date: dateKey,
            className: 'mark2'
          })
        }
      }
      this.changeMonth()

    },
    getUsersByOpenId () {
      this.$store.httpDispatch({})('getUserByDoctorId', {
        openid: this.$route.params.id
      })
      .then((res) => {
        if (res.data.code === 0) {
          this.user = res.data.data.retUser
          this.cureData()
        }
      })
    },
    getDate(time) {
      if (!time) {
        return ''
      }
      return moment(time).format('YYYY-MM-DD')
    },
    getTime(time) {
      if (!time) {
        return ''
      }
      return moment(time).format('HH:mm')
    },
    getToday () {
      let futureDayHide = moment().startOf('day').toDate().getTime() / 1000
      this.futureDayHide = futureDayHide.toString()
    },
    clickDay(data) {
      this.activeDay = this.getDate(data)
    },
    changeDate(data) {
    },
    changeMonth(data) {
      const activeMonth = data ? new moment(data) : new moment()
      this.usePer = 0
      if (!this.user.cureRecords) return
      const useRecords = []
      this.user.cureRecords.map((record) => {
        const activatedAt = this.getDate(this.user.startDate)
        const date = this.getDate(record)
        if (moment(activatedAt) <= moment(date) && moment(date).format('YYYY-MM') === activeMonth.format('YYYY-MM')) {
          useRecords.push(date)
        }
      })
      if (useRecords.length > 0) {
        let startDay = data ? new moment(data) : new moment()
        let endDay = data ? new moment(data) : new moment()
        startDay = startDay.startOf('month')
        endDay = endDay.endOf('month')
        if (moment() < endDay) {
          endDay = moment().endOf('day').subtract(1, 'day')
        }
        if (moment(this.user.startDate) > startDay) {
          startDay = moment(this.user.startDate).startOf('day')
        }
        let useDays = endDay.diff(startDay, 'day') + 1
        this.usePer = (useRecords.length / (useDays * 2)) * 100
        this.usePer = this.usePer.toFixed(2)
        this.usePer = this.usePer > 100 ? 100 : this.usePer
      }
    },
    clickToday(data) {
    }
  }
}
